import React from 'react';
import { useFormContext } from 'react-hook-form';
import { TextField, Box } from '@mui/material';

function validarRespuesta(valor) {
    // No espacios vacíos, dobles espacios, ni vacío
    const limpio = valor.replace(/\s+/g, ' ').trim();
    if (!limpio) return '';
    return limpio;
}

const FormNuevaPregunta = (props) => {
    // data vendrá en propsForm.data
    const { data } = props;
    const {
        register,
        formState: { errors },
        setValue,
        watch
    } = useFormContext();

    React.useEffect(() => {
        setValue('pregunta', data ? data.pregunta : '');
        setValue('respuesta', data ? data.respuesta : '');
    }, [data, setValue]);

    const pregunta = watch('pregunta') || '';
    const respuesta = watch('respuesta') || '';

    return (
        <>
            <Box mb={2}>
                <TextField
                    label="Pregunta"
                    {...register('pregunta', {
                        required: 'La pregunta es obligatoria.',
                        maxLength: { value: 250, message: 'Máximo 250 caracteres.' },
                        validate: (v) => v.replace(/\s+/g, ' ').trim() !== '' || 'La pregunta no puede estar vacía.'
                    })}
                    fullWidth
                    inputProps={{ maxLength: 250 }}
                    helperText={errors.pregunta ? errors.pregunta.message : `${pregunta.length}/250`}
                    error={!!errors.pregunta}
                />
            </Box>
            <Box mb={2}>
                <TextField
                    label="Respuesta"
                    {...register('respuesta', {
                        required: 'La respuesta es obligatoria.',
                        maxLength: { value: 450, message: 'Máximo 450 caracteres.' },
                        validate: (v) => validarRespuesta(v) !== '' || 'La respuesta no puede contener solo espacios.'
                    })}
                    fullWidth
                    multiline
                    inputProps={{ maxLength: 450 }}
                    helperText={errors.respuesta ? errors.respuesta.message : `${respuesta.length}/450`}
                    error={!!errors.respuesta}
                />
            </Box>
            <Box color="text.secondary" fontStyle="italic">
                Nota: Una vez guardada, esta pregunta no podrá ser modificada.
            </Box>
        </>
    );
};

export default FormNuevaPregunta;
